import EditableCards from "pages/ManagementPage/EditableCards/EditableCards";

export default EditableCards;
